import { InjectionToken } from '@angular/core';

export const SSR_REQUEST_URL = new InjectionToken<string>('SSR_REQUEST_URL');
